import script from "./AboutAccompany.vue?vue&type=script&setup=true&name=AboutAccompany&lang=js"
export * from "./AboutAccompany.vue?vue&type=script&setup=true&name=AboutAccompany&lang=js"

import "./AboutAccompany.vue?vue&type=style&index=0&id=0e83dace&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e83dace"]])

export default __exports__